
import aliPay from './ali-pay/src';
import antAliPay from './ant-ali-pay/src';
import audit from './audit/src';
import chanpay from './chanpay/src';
import customPayment from './custom-payment/src';
import payeeAccount from './payee-account/src';
import paymentsMethod from './payments-method/src';

const pluginObject = {
aliPay,
antAliPay,
audit,
chanpay,
customPayment,
payeeAccount,
paymentsMethod
}

let plugins = []
for(let item of Object.keys(pluginObject)){
  plugins = plugins.concat(pluginObject[item]
  
)
}
  

  
export default plugins;
